export default __webpack_public_path__ + "static/clipboard-debc4fd4b879024d7f6949f2a25c0d59.gif";